import { CreateUserSubscriptionLeaveMarkedInterface } from "../interfaces/UserSubscriptionLeaveMarkedInterface/CreateUserSubscriptionLeaveMarkedInterface";
import { UserSubscriptionLeaveMarkedInterface } from "../interfaces/UserSubscriptionLeaveMarkedInterface/UserSubscriptionLeaveMarkedInterface";
import BaseService from "./BaseService";

export class UserSubscriptionLeaveMarkedService extends BaseService<UserSubscriptionLeaveMarkedInterface, CreateUserSubscriptionLeaveMarkedInterface>{ 
    constructor(){
        let url: string = '/user-subscription-leave-marked/admin'
        super(url)
    }
}